"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.giftCardProductType = void 0;
const core_attributes_1 = require("./core-attributes");
const variant_attributes_1 = require("./variant-attributes");
const common_1 = require("./common");
exports.giftCardProductType = {
    name: 'Gift Card',
    key: common_1.ProductTypesEnum.GIFT_CARD,
    description: 'Gift Card',
    attributes: [
        core_attributes_1.styleCode,
        core_attributes_1.styleName,
        core_attributes_1.productType,
        core_attributes_1.productSubType,
        core_attributes_1.featureDescription,
        core_attributes_1.vertexTaxGroup,
        variant_attributes_1.priceDenomination,
        variant_attributes_1.ean,
        variant_attributes_1.upc,
        variant_attributes_1.occasion,
        core_attributes_1.newCommodityCode,
    ],
};
//# sourceMappingURL=gift-card.js.map